import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LoadGuard } from "./load.guard";
import { AuthGuard } from "./auth.guard";
import { LoginGuard } from "./login.guard";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "product-grid",
    canActivate: [AuthGuard, LoadGuard],
    loadChildren: () => import("./pages/product-grid/product-grid.module").then((m) => m.ProductGridPageModule),
  },
  {
    path: "login",
    loadChildren: () => import("./pages/login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "metro",
    canActivate: [AuthGuard, LoadGuard],

    loadChildren: () => import("./pages/metro/metro.module").then((m) => m.MetroPageModule),
  },
  {
    path: "product-detail",
    canActivate: [AuthGuard, LoadGuard],

    loadChildren: () => import("./pages/product-detail/product-detail.module").then((m) => m.ProductDetailPageModule),
  },
  {
    path: "related-product-detail/:id",
    canActivate: [AuthGuard, LoadGuard],
    loadChildren: () => import("./pages/product-detail/product-detail.module").then((m) => m.ProductDetailPageModule),
  },
  {
    path: "search-results/:text",
    canActivate: [AuthGuard, LoadGuard],

    loadChildren: () => import("./pages/search-page/search-results.module").then((m) => m.SearchResultsPageModule),
  },
  {
    path: "product/:urlTitle",
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/catalean-share/catalean-share.module").then((m) => m.CataleanSharePageModule),
  },
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
